import { useEffect, useRef } from 'react'

export default function useScrollListener(callback) {

  const savedCallback = useRef()

  const timerRef = useRef()

  savedCallback.current = callback

  useEffect(() => {
    const windowListener = () => {
      if(timerRef.current !== null) {
        clearTimeout(timerRef.current)
      }

      timerRef.current = setTimeout(() => {
        savedCallback.current()
      }, 100)
    }

    window.addEventListener('scroll', windowListener, false)

    return () => window.removeEventListener('scroll', windowListener, false)

  }, [])
}
